import type { ModelTreeProps } from "./model-tree.type";

import { DownOutlined } from "@ant-design/icons";
import { Spin, Tree as AntdTree } from "antd";

import ModelTreeItemTitle from "./model-tree-item-title";
import { useModelTree } from "./model-tree.hook";

import "./model-tree.style.less";

const ModelTree = (props: ModelTreeProps) => {
  const { loading } = props;
  const { treeItems, openedKeys, onItemExpandChange, onSelectItem } =
    useModelTree(props);

  return (
    <Spin spinning={loading}>
      <AntdTree
        expandedKeys={openedKeys}
        treeData={treeItems}
        onExpand={(expandedKeys, { expanded, node }) =>
          onItemExpandChange({ item: node, isExpanded: expanded, expandedKeys })
        }
        multiple={false}
        titleRender={(item) => <ModelTreeItemTitle item={item} />}
        onSelect={(_, { selectedNodes }) => onSelectItem(selectedNodes[0])}
        switcherIcon={<DownOutlined />}
        classNames={{ root: "model-tree--root" }}
      />
    </Spin>
  );
};

export default ModelTree;
